export const VSCODE_BASE_URL = 'vscode://vscode.git/clone?url=';
export const JETBRAINS_BASE_URL =
  'jetbrains://idea/checkout/git?idea.required.plugins.id=Git4Idea&checkout.repo=';
export const CODE_DROPDOWN_CLICK = 'click_code_dropdown';
export const COPY_SSH_CLONE_URL = 'copy_ssh_clone_url';
export const COPY_HTTPS_CLONE_URL = 'copy_https_clone_url';
export const OPEN_VSCODE_SSH = 'open_vscode_ssh';
export const OPEN_VSCODE_HTTPS = 'open_vscode_https';
export const OPEN_INTELLIJ_SSH = 'open_intellij_ssh';
export const OPEN_INTELLIJ_HTTPS = 'open_intellij_https';
export const IDE_TYPE_VSCODE = 'vscode';
export const IDE_TYPE_INTELLIJ = 'intellij';
export const OPEN_CUSTOM_IDE_LINK = 'user_opens_custom_code_dropdown_link';
export const EXTERNAL_LINK_REL = 'noopener noreferrer';
